import React from 'react';

const CreateCalendarPostContext = React.createContext({
  hasPermissions: false,
  selectedProfileIds: [],
});

export default CreateCalendarPostContext;
